import React, { useState, useEffect, useContext } from 'react';
import { createProject, updateUnits, getUsers, createClinet, updateClinet } from '../../../../Utility/Api';
import { toast } from 'react-toastify';
import { WarehouseContext } from '../../../../Utility/UserContext';



const AddClinetForm = ({ openModal, setOpenModal, unit, closeModal, refreshList }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [users, setUsers] = useState([]);
  const [selectedManager, setSelectedManager] = useState([]);
  const [SelectedTeams, setSelectedTeams] = useState([]);

  const { showLoader, hideLoader, shopItem } = useContext(WarehouseContext);

  useEffect(() => {
    fetchUsers();
  }, []);






  const fetchUsers = async (page = 1, text = "") => {
    try {
      const response = await getUsers(page, text, shopItem.shop_id);
      if (response.data && response.data.data) {
        setUsers(response.data.data);
        // setTotalPages(response.data.pagination.total_pages);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      toast.error("Failed to fetch user data");
    }
  };


  const [clientData, setClinetdata] = useState({
    first_name: '',
    last_name: '',
    email: "",
    phone: "",
    country: "",
    city: "",
    company_name: "",
    company_contact: "",
    company_address: "0",
    website: "1",
    company_email: "",
    postal_code: "",
  });
  const [errors, setErrors] = useState({});
  const [isScreenshotEnabled, setIsScreenshotEnabled] = useState(false);
  const [calculate, setCalculate] = useState({
    hourly_rate: '',
    total_hours: ''
  })


  const handleSelectManager = (ID) => {
    setSelectedManager((prevState) => {
      if (prevState.includes(ID)) {
        return prevState.filter((item) => item !== ID);
      } else {
        return [...prevState, ID];
      }
    });
    console.log(ID);
  };


  const handleSelectTeams = (ID) => {
    setSelectedTeams((prevState) => {
      if (prevState.includes(ID)) {
        return prevState.filter((item) => item !== ID);
      } else {
        return [...prevState, ID];
      }
    });
    console.log(ID);
  };

  const [allMember, setAllmember] = useState(false);

  const handleToggleChange = () => {
    setIsScreenshotEnabled((prevState) => !prevState);
    // Log the value as 1 or 0 based on the checkbox state
    const value = !isScreenshotEnabled ? "true" : "false";
    console.log("Billable enabled value:", value);
    setClinetdata({
      ...clientData,
      is_billable: value,
    });
  };




  const handleInputChange = (e) => {
    const { name, value } = e.target;
  
    setClinetdata({
      ...clientData,
      [name]: value,
    });

  };

  const projecttype = [
    { id: '1', title: 'Fixed Cost' },
    { id: '2', title: 'Retainer' },
    { id: '3', title: 'Time & Material' },
  ]
  useEffect(() => {
    if (unit) {
    setClinetdata({
    first_name: unit.first_name,
    last_name:unit.last_name,
    email:unit.email,
    phone:unit.phone,
    country:unit.country,
    city:unit.city,
    company_name:unit.company_name,
    company_contact:unit.company_contact,
    company_address:unit.company_address,
    website:unit.website,
    company_email:unit.company_email,
    postal_code:unit.postal_code,
      });
    }
  }, [unit]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setClinetdata((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };


  const handlePrevious = () => {
    setCurrentStep(currentStep - 1);
  };

useEffect(()=>{
  console.log('clientData',clientData)
},[clientData])



  const handleNext = () => {
    if (currentStep == 1 && (!clientData.first_name || !clientData.last_name || !clientData.email ||  !clientData.phone || !clientData.country || !clientData.city)) {
      toast.error("Required all fields");
      return;
    }

    if (currentStep == 2 && (!clientData.company_name || !clientData.company_contact || !clientData.company_address || !clientData.website || !clientData.company_email || !clientData.postal_code)) {
      toast.error("Required all fields");
      return;
    }
    setCurrentStep(currentStep + 1);
  };



  const handleSubmit = async (e) => {
    showLoader()
    e.preventDefault();

    if (!clientData.first_name) {
      toast.error('First Name is required');
      return;
    }


    try {
      if (unit) {
        await updateClinet(unit.id, clientData);
        hideLoader()
        toast.success('client updated successfully');
      } else {
        try {
          const response = await createClinet(clientData);  // API call
          hideLoader();

          if (response) {  // Check API response status
            toast.success('Client added successfully');
          } else {
            toast.error('Failed to add project');
          }
        } catch (error) {
          hideLoader();
          console.error("Error creating project:", error);
          toast.error('An error occurred while adding the project');
        }
      }
      closeModal();
      hideLoader()
      refreshList();
    } catch (error) {
      console.error('Error saving unit data:', error);
      hideLoader()
      toast.error('Error saving unit');
    }
  };

  return (
    <div className={`modal fade ${openModal ? "show" : ""}`} style={{ display: 'block' }} tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" style={{ fontFamily: 'poppins' }}>
              {unit ? 'Edit Project' : 'Add Client'}
            </h5>
            <button type="button" className="btn-close" aria-label="Close" onClick={closeModal}></button>
          </div>
          <div className="modal-body" style={{ fontFamily: 'poppins' }}>
            <form className="">
              {/* Step Indicators */}
              <div className="step-indicator mb-5 mt-3">
                <span className={`step ${currentStep === 1 ? 'active' : currentStep > 1 ? 'completed' : ''}`}>1</span>
                <span className={`step ${currentStep === 2 ? 'active' : currentStep > 2 ? 'completed' : ''}`}>2</span>
            
              </div>

              {/* <span className={`step ${currentStep === 4 ? 'active' : ''}`}>4</span> */}

              {/* Form Sections based on Current Step */}

              {currentStep === 1 && (
                <>
                  <div className="form-group row">
                    <div className={`form-group col-sm-12 col-lg-6 col-md-6 mb-3`}>
                      <label htmlFor="title" style={{ fontSize: 15, fontWeight: 'bold', color: '#495057' }}
                      >First Name :</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder='Enter First Name '
                        id="first_name"
                        name="first_name"
                        style={{ fontSize: 14 }}
                        value={clientData.first_name}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className={`form-group col-sm-12 col-lg-6 col-md-6 mb-3`}>
                      <label htmlFor="title" style={{ fontSize: 15, fontWeight: 'bold', color: '#495057' }}
                      >Last Name :</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder='Enter Last Name'
                        id="last_name"
                        name="last_name"
                        style={{ fontSize: 14 }}
                        value={clientData.last_name}
                        onChange={handleInputChange}
                      />
                    </div>
               
                  </div>

                  <div className="form-group row">
                    <div className={`form-group col-sm-12 col-lg-6 col-md-6 mb-3`}>
                      <label htmlFor="title" style={{ fontSize: 15, fontWeight: 'bold', color: '#495057' }}
                      >Email :</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder='Enter Email '
                        id="email"
                        name="email"
                        style={{ fontSize: 14 }}
                        value={clientData.email}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className={`form-group col-sm-12 col-lg-6 col-md-6 mb-3`}>
                      <label htmlFor="title" style={{ fontSize: 15, fontWeight: 'bold', color: '#495057' }}
                      >Phone :</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder='Enter Phone Number'
                        id="phone"
                        name="phone"
                        style={{ fontSize: 14 }}
                        value={clientData.phone}
                        onChange={handleInputChange}
                      />
                    </div>
               
                  </div>
                 
               
                  <div className="form-group row">
                    <div className={`form-group col-sm-12 col-lg-6 col-md-6 mb-3`}>
                      <label htmlFor="title" style={{ fontSize: 15, fontWeight: 'bold', color: '#495057' }}
                      >Country :</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder='Enter Country '
                        id="country"
                        name="country"
                        style={{ fontSize: 14 }}
                        value={clientData.country}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className={`form-group col-sm-12 col-lg-6 col-md-6 mb-3`}>
                      <label htmlFor="title" style={{ fontSize: 15, fontWeight: 'bold', color: '#495057' }}
                      >City :</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder='Enter city'
                        id="city"
                        name="city"
                        style={{ fontSize: 14 }}
                        value={clientData.city}
                        onChange={handleInputChange}
                      />
                    </div>
               
                  </div>
                </>
              )}

             

              {false && (
                <>
                  {/* Client Name, Start Date, End Date, Hourly Rate, and Is Billable */}
                  <div className={`form-group row`}>
                    <div className={`form-group col-md-6`}>
                      <label htmlFor="client_id" style={{ fontSize: 15, fontWeight: 'bold', color: '#495057' }}>Client Name:</label>
                      <select
                        className="form-control"
                        id="client_id"
                        name="client_id"
                        value={clientData.client_id}
                        onChange={handleInputChange}
                        style={{ fontSize: 14 }}
                      >
                        <option disabled selected value="" >
                          Select Client
                        </option>
                        {/* {clients.map((client) => (
                      <option value={client.id} key={client.id}>
                        {client.first_name} {client.last_name}
                      </option>
                    ))} */}
                      </select>
                    </div>
                  </div>

                  <div className="form-group row">
                    <div
                      className={`form-group col-md-6 align-items-center d-flex align-items-center`}
                    >
                      <label
                        htmlFor="screenshotToggle"
                        className="col-form-label mr-2" style={{ fontSize: 14 }}
                      >
                        Is Billable:
                      </label>
                      <label className="switch mb-0">
                        <input
                          type="checkbox"
                          checked={isScreenshotEnabled}
                          onChange={handleToggleChange}
                        />
                        <span className="slider round"></span>
                      </label>
                    </div>
                  </div>
                  <div className={`form-group row`}>
                    <div className="form-group col-md-6">
                      <label htmlFor="start_date" style={{ fontSize: 14 }}>Start Date :</label>
                      <input
                        type="date"
                        className="form-control"
                        id="start_date"
                        name="start_date"
                        style={{ fontSize: 14 }}
                        value={clientData.start_date}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="end_date" style={{ fontSize: 14 }}>End Date :</label>
                      <input
                        type="date"
                        className="form-control"
                        id="end_date"
                        name="end_date"
                        style={{ fontSize: 14 }}
                        value={clientData.end_date}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                </>
              )}

              {currentStep === 2 && (
                <>
                  {/* Hourly Rate, Notify At, Total Hours, Total Cost, Project Status */}
                  <div className="form-row row mb-3">
                    <div className={`form-group col-md-6`}>
                      <label htmlFor="company_name" style={{ fontSize: 15, fontWeight: 'bold', color: '#495057' }}>Company Name :</label>
                      <input
                        type="text"
                        className="form-control"
                        id="company_name"
                        name="company_name"
                        placeholder='Enter Company Name'
                        style={{ fontSize: 14 }}
                        value={clientData.company_name}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className={`form-group col-md-6`}>
                      <label htmlFor="website" style={{ fontSize: 15, fontWeight: 'bold', color: '#495057' }}>Website :</label>
                      <input
                        type="text"
                        className="form-control"
                        id="website"
                        name="website"
                        placeholder='Enter Website'
                        style={{ fontSize: 14 }}
                        value={clientData.website}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="form-row row mb-3">
                    <div className={`form-group col-md-6`}>
                      <label htmlFor="company_contact" style={{ fontSize: 15, fontWeight: 'bold', color: '#495057' }}>Company Contact :</label>
                      <input
                        type="text"
                        className="form-control"
                        id="company_contact"
                        placeholder='Enter Company Contact'
                        name="company_contact"
                        style={{ fontSize: 14 }}
                        value={clientData.company_contact}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className={`form-group col-md-6 `}>
                      <label htmlFor="company_email" style={{ fontSize: 15, fontWeight: 'bold', color: '#495057' }}>Company Email :</label>
                      <input
                        type="email"
                        className="form-control"
                        id="company_email"
                        placeholder='Enter Company Email'
                        name="company_email"
                        style={{ fontSize: 14 }}
                        value={clientData.company_email}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="form-row row mb-3">
                    <div className={`form-group col-md-6`}>
                      <label htmlFor="company_address" style={{ fontSize: 15, fontWeight: 'bold', color: '#495057' }}>Company Address  :</label>
                      <input
                        type="text"
                        className="form-control"
                        id="company_address"
                        placeholder='Enter Company Address'
                        name="company_address"
                        style={{ fontSize: 14 }}
                        value={clientData.company_address}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className={`form-group col-md-6 `}>
                      <label htmlFor="postal_code" style={{ fontSize: 15, fontWeight: 'bold', color: '#495057' }}>Company Postal Code :</label>
                      <input
                        type="text"
                        className="form-control"
                        id="postal_code"
                        placeholder='Enter Postal Code'
                        name="postal_code"
                        style={{ fontSize: 14 }}
                        value={clientData.postal_code}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                </>
              )}

            </form>
          </div>
          <div className="modal-footer">
            {currentStep == 1 && (
              <button type="button" className="btn btn-secondary" onClick={() => setOpenModal(false)}>
                close
              </button>
            )}
            {currentStep > 1 && (
              <button type="button" className="btn btn-secondary" onClick={handlePrevious}>
                Previous
              </button>
            )}
            {currentStep < 2 && (
              <button type="button" className="btn btn-success" onClick={handleNext}>
                Continue
              </button>
            )}
            {currentStep === 2 && (
              <button type="button" className="btn btn-success" onClick={handleSubmit}>
                {unit ? "Update Client" : "Add Client" }
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddClinetForm;
